import { render, staticRenderFns } from "./TypologySelect.vue?vue&type=template&id=3ed4c0fb"
import script from "./TypologySelect.vue?vue&type=script&lang=ts"
export * from "./TypologySelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports